var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Report" },
    [
      _c("div", { staticClass: "Report-topo" }),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-center align-center pa-8" },
            [
              _c("v-progress-circular", {
                attrs: { size: 35, color: "primary", indeterminate: "" }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-card",
        { attrs: { width: "100vw" } },
        [
          _c("div", { staticClass: "divImagemPrinting" }, [
            _c(
              "button",
              {
                staticClass: "buttonImagemPrinting",
                on: { click: _vm.downloadCsv }
              },
              [
                _c("v-img", {
                  staticClass: "imagem_printing",
                  attrs: { src: require("../../../assets/icons/printing.svg") }
                })
              ],
              1
            )
          ]),
          _c(
            "v-container",
            {
              staticClass: "container",
              attrs: { fluid: "", "fill-height": "" }
            },
            [
              _c(
                "v-row",
                { staticClass: "top", attrs: { justify: "space-between" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "col-2 coluna-input",
                      attrs: { cols: "12", sm: "6", md: "3" }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          rounded: "",
                          outlined: "",
                          dense: "",
                          disabled: _vm.loading,
                          type: "date",
                          name: "",
                          id: ""
                        },
                        on: { input: _vm.dataInicialChange },
                        model: {
                          value: _vm.dataInicial,
                          callback: function($$v) {
                            _vm.dataInicial = $$v
                          },
                          expression: "dataInicial"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "top-rate",
                      attrs: { cols: "12", sm: "6", md: "4" }
                    },
                    [
                      _c("span", { staticClass: "title-data" }, [
                        _vm._v(_vm._s(_vm.rate))
                      ])
                    ]
                  )
                ],
                1
              ),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: { headers: _vm.headers, items: _vm.desserts },
                on: {
                  "click:row": function($event) {
                    return _vm.handleClick($event)
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.ativo",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c("div", { class: _vm.getHeader(item) }, [
                            _c("span", [_vm._v(_vm._s(item.ativo))])
                          ])
                        ]
                      }
                    },
                    {
                      key: "item.valor",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c("div", [
                            _c("span", [
                              _vm._v(_vm._s(_vm.formatCurrency(item.valor)))
                            ])
                          ])
                        ]
                      }
                    },
                    {
                      key: "item.quantidade",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c("div", [
                            _c("span", [_vm._v(_vm._s(item.quantidade))])
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ],
        1
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c(
        "v-card",
        { attrs: { width: "100vw" } },
        [
          _c("v-col", { attrs: { cols: "12", sm: "6", md: "3" } }, [
            _c("span", { staticClass: "title-data" }, [_vm._v("Movimentação")])
          ]),
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: { headers: _vm.headers2, items: _vm.movimentos },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.ativo",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("div", [_c("span", [_vm._v(_vm._s(item.ativo))])])
                    ]
                  }
                },
                {
                  key: "item.valor",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("div", [
                        _c("span", [
                          _vm._v(_vm._s(_vm.formatCurrency(item.valor)))
                        ])
                      ])
                    ]
                  }
                },
                {
                  key: "item.valor1",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("div", [
                        _c("span", [
                          _vm._v(_vm._s(_vm.formatCurrency(item.valor1)))
                        ])
                      ])
                    ]
                  }
                },
                {
                  key: "item.quantidade",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("div", [_c("span", [_vm._v(_vm._s(item.quantidade))])])
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }